var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('em',{staticClass:"lt_text"},[_vm._v("Dept A")]),_vm._v(" "),_c('span',{staticClass:"int_type_no_border mgr_5"},[_c('CodeSelect',{attrs:{"className":"tbl_select sm_int","codes":_vm.codes},on:{"input":_vm.updateValue},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }